import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./table.module.css";
export var Table = function(table) {
    return /*#__PURE__*/ _jsxs("table", {
        className: styles.table,
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsx("tr", {
                    children: table.thead.map(function(heading) {
                        return /*#__PURE__*/ _jsx("th", {
                            children: heading.value
                        }, heading._uid);
                    })
                })
            }),
            /*#__PURE__*/ _jsx("tbody", {
                children: table.tbody.filter(function(row) {
                    return !!row.body[0].value;
                }).map(function(row) {
                    return /*#__PURE__*/ _jsx("tr", {
                        children: row.body.map(function(cell) {
                            return /*#__PURE__*/ _jsx("td", {
                                children: cell.value
                            }, cell._uid);
                        })
                    }, row._uid);
                })
            })
        ]
    });
};
